import { ColumnActionsMode } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import {
  rightAlignHeaderStyle,
  commonColumnPropsConst as commonColumnProps,
} from 'common/utils/columnUtilities';

export const _columns: ColumnData[] = [
  {
    key: '_documentPoolName',
    name: 'Folder',
    fieldName: '_documentPoolName',
    minWidth: 90,
    maxWidth: 120,
    ...commonColumnProps,
  },
  {
    key: 'indexName',
    name: 'Name',
    fieldName: 'indexName',
    minWidth: 170,
    ...commonColumnProps,
  },
  {
    key: 'indexReferenceNumber',
    name: 'Number',
    fieldName: 'indexReferenceNumber',
    minWidth: 100,
    ...commonColumnProps,
  },
  {
    key: 'indexTransactionDate',
    name: 'Date',
    fieldName: 'indexTransactionDate',
    minWidth: 70,
    maxWidth: 70,
    ...commonColumnProps,
  },
  {
    key: '_documentContents',
    name: 'Contents',
    fieldName: '_documentContents',
    minWidth: 180,
    ...commonColumnProps,
  },
  {
    key: 'view',
    name: '',
    fieldName: 'view',
    minWidth: 20,
    maxWidth: 20,
    ...commonColumnProps,
    isResizable: false,
    columnActionsMode: ColumnActionsMode.disabled,
  },

  {
    key: 'fileReference',
    name: 'Documents',
    fieldName: 'fileReference',
    minWidth: 120,
    isResizable: true,
  },
  {
    key: 'indexAmount',
    name: 'Total',
    fieldName: 'indexAmount',
    minWidth: 60,
    maxWidth: 60,
    ...commonColumnProps,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'isoCode',
    name: 'Currency',
    fieldName: 'isoCode',
    minWidth: 60,
    maxWidth: 60,
    ...commonColumnProps,
  },
  {
    key: 'Comment',
    name: 'Comments',
    fieldName: 'comment',
    minWidth: 60,
    maxWidth: 60,
    ...commonColumnProps,
  },
  {
    key: '_uploadDate',
    name: 'Uploaded',
    fieldName: '_uploadDate',
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
    ...commonColumnProps,
  },
];
